import { useSyncExternalStore } from "react";

const changed = "brian-email-read-changed";
const subscribe = (listener: () => void) => {
  window.addEventListener("storage", listener);
  window.addEventListener(changed, listener);
  return () => {
    window.removeEventListener("storage", listener);
    window.removeEventListener(changed, listener);
  };
};
const read = (key: string) => {
  try {
    return localStorage.getItem(key) ?? "{}";
  } catch {
    return "{}";
  }
};
const parse = (value: string): Record<string, string> => {
  try {
    const result: unknown = JSON.parse(value);
    if (result && typeof result === "object" && !Array.isArray(result))
      return Object.fromEntries(
        Object.entries(result).filter(([, id]) => typeof id === "string"),
      );
  } catch {
    /* Ignore invalid or unavailable browser storage. */
  }
  return {};
};
export const useEmailReadMarkers = (key: string) =>
  parse(
    useSyncExternalStore(
      subscribe,
      () => read(key),
      () => "{}",
    ),
  );

export const markEmailRead = (
  storageKey: string,
  conversationKey: string,
  messageId: string,
) => {
  const saved = parse(read(storageKey));
  if (saved[conversationKey] === messageId) return;
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({ ...saved, [conversationKey]: messageId }),
    );
    window.dispatchEvent(new Event(changed));
  } catch {
    /* Reading mail must work when storage is unavailable. */
  }
};
